import { get } from 'js-cookie';

export default function getCsrfToken() {
    return get('_99csrf');
}
